module.exports = __webpack_public_path__ + "img/favorites.f591be56.svg";